import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  title: 'It’s a Christmas <b>MA</b>t<b>CH</b>: <b>Collaborative solutions</b> for a worry-free new year',
  description: '<p>Discover how MACH Architecture and freshcells can make your digital projects shine.</p>',
  btnText: 'Learn more',
})
